import React from 'react';
import { Header } from '../components/Header';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { ArrowLeftIcon, PlusIcon } from 'lucide-react';
interface MembersScreenProps {
  onBack: () => void;
  onLogout: () => void;
  onNavigateCases: () => void;
}
export function MembersScreen({
  onBack,
  onLogout,
  onNavigateCases
}: MembersScreenProps) {
  const members = [{
    email: 'partner@smithfirm.com',
    role: 'Admin',
    access: 'Full',
    date: 'Oct 12, 2023'
  }, {
    email: 'associate1@smithfirm.com',
    role: 'Reviewer',
    access: 'Assigned Batches',
    date: 'Oct 14, 2023'
  }, {
    email: 'paralegal@smithfirm.com',
    role: 'Enricher',
    access: 'Full',
    date: 'Oct 15, 2023'
  }, {
    email: 'contract.attorney@external.com',
    role: 'Reviewer',
    access: 'Assigned Batches',
    date: 'Nov 02, 2023'
  }];
  const getRoleBadge = (role: string) => {
    switch (role) {
      case 'Admin':
        return 'amber';
      case 'Reviewer':
        return 'blue';
      case 'Enricher':
        return 'teal';
      default:
        return 'default';
    }
  };
  return <div className="min-h-screen flex flex-col bg-navy" data-id="element-695" data-mp="lkqo365m2lme">
      <Header breadcrumbs={[{
      label: 'Cases',
      onClick: onNavigateCases
    }, {
      label: 'Smith v. Acme Corp',
      onClick: onBack
    }, {
      label: 'Team Members'
    }]} onLogout={onLogout} data-id="element-696" data-mp="qkv5cyecfkdo" />

      <main className="flex-1 p-8 max-w-5xl mx-auto w-full" data-id="element-697" data-mp="hl8f98r2e0zx">
        <button onClick={onBack} className="flex items-center text-sm text-gray-400 hover:text-white mb-6 transition-colors" data-id="element-698" data-mp="2vamsgm3qp4x">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-699" data-mp="7uvkyotg6tgl" />
          Back to Case Overview
        </button>

        <div className="flex items-start justify-between mb-8" data-id="element-700" data-mp="3q0idu6vqwo2y">
          <div data-id="element-701" data-mp="3u23odlkt4q9z">
            <h1 className="text-3xl font-serif text-white mb-2" data-id="element-702" data-mp="3u0ir3o73yt8f">Case Access</h1>
            <p className="text-gray-400" data-id="element-703" data-mp="20jd3op24q362">
              Manage who can access Smith v. Acme Corp.
            </p>
          </div>
          <Button className="gap-2" data-id="element-704" data-mp="1vrcx4drk0c0i">
            <PlusIcon className="w-4 h-4" data-id="element-705" data-mp="1vqbijzbbx7e1" />
            Add User
          </Button>
        </div>

        <div className="bg-navy-light border border-navy-lighter rounded-lg overflow-hidden" data-id="element-706" data-mp="1qqp4jnnofn46">
          <div className="grid grid-cols-[2fr_1fr_1.5fr_1fr_80px] gap-4 px-6 py-4 border-b border-navy-lighter bg-navy text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-707" data-mp="1ls44ppcc75g9">
            <div data-id="element-708" data-mp="2ejfejrc0rwbt">Email</div>
            <div data-id="element-709" data-mp="29jjbpvf26axu">Role</div>
            <div data-id="element-710" data-mp="29irrfgqwvzmv">Case Access</div>
            <div data-id="element-711" data-mp="29hyh65squrzz">Date Granted</div>
            <div className="text-right" data-id="element-712" data-mp="25hy3wohdsmui">Action</div>
          </div>

          <div className="divide-y divide-navy-lighter" data-id="element-713" data-mp="25hob6t4yc1l4">
            {members.map((member, i) => <div key={i} className="grid grid-cols-[2fr_1fr_1.5fr_1fr_80px] gap-4 px-6 py-4 items-center text-sm hover:bg-navy-hover transition-colors" data-id="element-714" data-mp="y5pc0p0jtg4a" data-mpi={i}>
                <div className="text-white font-medium" data-id="element-715" data-mp="35rz22u4mi7wv">{member.email}</div>
                <div data-id="element-716" data-mp="39sj3i9w8bxot">
                  <Badge variant={getRoleBadge(member.role)} data-id="element-717" data-mp="39rzlyuahrbbb">
                    {member.role}
                  </Badge>
                </div>
                <div className="text-gray-300" data-id="element-718" data-mp="3ji2lldc4bnim">{member.access}</div>
                <div className="text-gray-400" data-id="element-719" data-mp="3jjdpdd5kcv9q">{member.date}</div>
                <div className="text-right" data-id="element-720" data-mp="3ofueoaoi1foe">
                  <button className="text-red-400 hover:text-red-300 text-sm transition-colors" data-id="element-721" data-mp="3tfp22492fn4p">
                    Remove
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        <p className="mt-4 text-xs text-gray-500 text-center" data-id="element-722" data-mp="69y4dtf82m7y">
          Contact support to modify role permissions.
        </p>
      </main>
    </div>;
}